module.exports = require("@splunk/themes/variables");